export default {"src":"/_next/static/media/ELAN.3c5f94b6.svg","height":18,"width":18};